import React from 'react';
import { Container } from 'react-bootstrap';
import { isMobile, isTablet } from 'react-device-detect';

type LayoutProps = {
  children: React.ReactNode;
  isShellMode?: boolean;
};
const Layout: React.FC<LayoutProps> = ({ children, isShellMode = false }) => {
    // eslint-disable-next-line no-nested-ternary
    const containerClass = isShellMode
        ? 'shellContainer'
        : isMobile || isTablet
            ? 'mobileContainer loc-mob'
            : 'webContainer loc-web';
    return (

        <Container role="main" className={containerClass}>
            {children}
        </Container>
    );
};

export default Layout;
